import { NotesIcon } from '@va/icons';
import { useTranslate } from '@va/localization';
import { IconWithBackground, ToggleActionCard } from '@va/ui/design-system';
import classNames from 'classnames';
import { useCallback } from 'react';
import { NewsletterSettingsFormFields, useNewsletterSettings } from './useNewsletterSettings';

type NewsletterToggleProps = {
  size?: 'small' | 'medium' | 'large';
  className?: string;
};

export const NewsletterToggle = ({ size = 'large', className }: NewsletterToggleProps) => {
  const translate = useTranslate();
  const { isNLSubscribed, values, onSubscriptionChange, isSubscriptionLoading, handleSubmit } = useNewsletterSettings();

  const onChange = useCallback(
    async (value: any) => {
      await onSubscriptionChange(value);
      handleSubmit();
    },
    [handleSubmit, onSubscriptionChange],
  );

  if (isNLSubscribed || isSubscriptionLoading) return null;

  return (
    <ToggleActionCard
      title={translate('onboarding.newsletterStep.newsletter')}
      name={NewsletterSettingsFormFields.newsletter}
      value={values.newsletter}
      handleChange={onChange}
      icon={() => (
        <IconWithBackground
          className={classNames({
            'w-10u! h-10u!': size === 'small',
          })}
          icon={() => <NotesIcon color='#696969' />}
        />
      )}
      wrapperClass={className}
      size={size}
    />
  );
};
